import { makeActionCreator } from '../../config/store/utils'
import { getRegions } from '../../services/config'
import { getRegionalKPIs } from '../../services/regions'
import { REGIONS_DICTIONARY } from './RegionalSection.utils'

const REGION_COLLECTION = [15, 1, 2, 3, 4, 5, 13, 6, 7, 16, 8, 9, 14, 10, 11, 12]

export const GET_REGIONS = 'GET_REGIONS'
export const GET_REGIONS_ERROR = 'GET_REGIONS_ERROR'
export const GET_REGIONS_SUCCESS = 'GET_REGIONS_SUCCESS'
export const onGetRegions = makeActionCreator(GET_REGIONS)
export const onGetRegionsError = makeActionCreator(GET_REGIONS_ERROR, 'payload')
export const onGetRegionsSuccess = makeActionCreator(GET_REGIONS_SUCCESS, 'payload')
export const onGetRegionsThunk = () => async dispatch => {
  dispatch(onGetRegions())

  try {
    const { data } = await getRegions()
    const options = REGION_COLLECTION.map(index => {
      const found = data.payload.find(region => region.id === index)

      return { id: found.id, name: found.name, value: REGIONS_DICTIONARY[found.id].value }
    })

    return dispatch(onGetRegionsSuccess({ options }))
  } catch (error) {
    return dispatch(onGetRegionsError({ error }))
  }
}

export const GET_REGIONAL_KPIS = 'GET_REGIONAL_KPIS'
export const GET_REGIONAL_KPIS_ERROR = 'GET_REGIONAL_KPIS_ERROR'
export const GET_REGIONAL_KPIS_SUCCESS = 'GET_REGIONAL_KPIS_SUCCESS'
export const onGetRegionalKPIs = makeActionCreator(GET_REGIONAL_KPIS)
export const onGetRegionalKPIsError = makeActionCreator(GET_REGIONAL_KPIS_ERROR, 'payload')
export const onGetRegionalKPIsSuccess = makeActionCreator(GET_REGIONAL_KPIS_SUCCESS, 'payload')
export const onGetRegionalKPIsThunk = payload => async dispatch => {
  dispatch(onGetRegionalKPIs())

  try {
    const { data } = await getRegionalKPIs({ regionId: payload.regionId, year: payload.year })
    const [KPIs] = data.payload || []

    return dispatch(
      onGetRegionalKPIsSuccess({
        amount: KPIs.regionAmountCLP,
        amountUSD: KPIs.regionAmountUSD,
        biddings: KPIs.regionLicAwarded,
        id: payload.regionId,
        name: KPIs.region,
        orders: KPIs.regionNroOC
      })
    )
  } catch (error) {
    return dispatch(onGetRegionalKPIsError({ error }))
  }
}
